import _ from "lodash";
import React, { useEffect, useRef } from "react";
import { TextInput } from "@toddle-edu/ds-web";
import PropTypes from "prop-types";
import { useI18n } from "Hooks";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
} from "../../modules/Utils";
import { connect } from "react-redux";
import classes from "./EventTitle.scss"; // Assuming you have a CSS module for styling
import classNames from "classnames";

const MAX_TITLE_LENGTH = 100;

const inputStyle = {
  borderRadius: "0px",
  paddingLeft: "8px",
  marginLeft: "-8px",
  background: "unset",
  paddingBottom: "4px",
};
const EventTitle = props => {
  const {
    variant,
    eventModalV2,
    updateEventModalV2,
    containerClass = "",
    characterCountClass = "",
    testId = "",
    placeholder = "",
  } = props;
  const { t } = useI18n(["calendar"]);
  const titleLength = eventModalV2?.eventTitle?.length || 0;

  const setEventTitle = setValue("eventTitle", updateEventModalV2);
  const textRef = useRef(null);

  const debouncedSetEventTitle = useRef(
    _.debounce(value => {
      setEventTitle(value);
    }, 300)
  );

  const onBlur = e => {
    setEventTitle(e?.target?.value);
  };

  const onChange = e => {
    const value = e?.target?.value;
    if (value.length <= MAX_TITLE_LENGTH) {
      if (textRef.current) {
        textRef.current.innerText = `${value.length}/${MAX_TITLE_LENGTH}`;
      }
      debouncedSetEventTitle.current(value);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  return (
    <div className={classes.eventTitleContainer}>
      <div className={classNames(classes.container, containerClass)}>
        <TextInput
          variant={variant}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={`${
            placeholder ? placeholder : t("calendar:event_title")
          } *`}
          defaultValue={eventModalV2?.eventTitle || ""}
          data-class={"textInput"}
          className={classes.inputContainer}
          style={inputStyle}
          ref={inputRef}
          maxLength={MAX_TITLE_LENGTH}
          testId={`${testId}-eventTitle`}
        />
      </div>
      <span
        className={classNames(classes.characterCount, characterCountClass)}
        ref={textRef}
      >
        {titleLength}/{MAX_TITLE_LENGTH}
      </span>
    </div>
  );
};

EventTitle.defaultProps = {
  variant: "plain",
  eventModalV2: {},
  updateEventModalV2: () => {},
};
EventTitle.propTypes = {
  variant: PropTypes.oneOf(["plain", "outlined"]),
  updateEventModalV2: PropTypes.func,
  eventModalV2: PropTypes.object,
};
export default connect(mapStateToProps, mapActionCreators)(EventTitle);
